import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { theme } from 'coreOld/themes';

interface WrapperProps {
  isHeaderFixed?: boolean;
  children?: ReactNode;
}

export const Wrapper = styled.div<WrapperProps>(
  ({ theme, isHeaderFixed }) => css`
    background-color: ${theme.palette.backgrounds.primary};
    border-bottom: ${`1px solid ${theme.palette.borderColor}`};
    display: flex;
    flex-wrap: wrap;
    margin-top: ${isHeaderFixed ? `${theme.topFixedHeaderHeight}px` : '0'};

    padding: 29px 29px 25px;
    transition: all 0.3s linear;
    width: 100%;

    @media (min-width: 992px) {
      padding: 16px 29px;
    }
  `
);

interface RowWrapperProps {
  hasPaddingBottom?: boolean;
  children?: ReactNode;
}

export const RowWrapper = styled.div<RowWrapperProps>`
  display: flex;
  justify-content: space-between;
  width: 100%;

  ${({ hasPaddingBottom }) =>
    hasPaddingBottom &&
    css`
      padding-bottom: 20px;
    `}
`;

interface TitleWrapperProps {
  children?: ReactNode;
}

export const TitleWrapper = styled.div<TitleWrapperProps>``;

interface SubTitleProps {
  children?: ReactNode;
}

export const SubTitle = styled.div<SubTitleProps>`
  font:
    600 19px 'Open Sans',
    sans-serif;
  color: ${({ theme }) => theme.palette.neutral.dark};
  letter-spacing: -0.04em;
  margin-left: 5px;
  margin-top: 5px;
`;

interface ButtonWrapperProps {
  children?: ReactNode;
}

export const ButtonWrapper = styled.div<ButtonWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 33px;
`;

interface CenteredProps {
  hasMarginRight?: boolean;
  children?: ReactNode;
}

export const Centered = styled.div<CenteredProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 30px;

  ${({ hasMarginRight }) =>
    hasMarginRight &&
    css`
      margin-right: 16px;
    `}
`;

export const iconStyle = {
  width: 30,
  height: 30,
  color: theme.palette.backgrounds.contrast,
};
